/**
 * Messages d'erreur zod en français (DECISIONS §0.4 : tout est en français).
 *
 * Le validateur de contenu est lu par eq-game-design, et les messages d'erreur d'API sont des
 * messages de secours français (DECISIONS §9.4) : les laisser en anglais de bibliothèque serait
 * une régression de lisibilité. On installe donc une carte d'erreurs globale, une seule fois,
 * au chargement du package.
 */
import { z } from 'zod';
function attendu(type) {
    switch (type) {
        case 'string':
            return 'une chaîne de caractères';
        case 'number':
            return 'un nombre';
        case 'integer':
            return 'un entier';
        case 'boolean':
            return 'un booléen';
        case 'array':
            return 'un tableau';
        case 'object':
            return 'un objet';
        case 'null':
            return 'null';
        case 'undefined':
            return 'undefined';
        default:
            return type;
    }
}
export const carteErreursFrancais = (issue, contexte) => {
    switch (issue.code) {
        case z.ZodIssueCode.invalid_type: {
            if (issue.received === 'undefined' || issue.received === 'null') {
                return { message: 'champ obligatoire manquant' };
            }
            return { message: `type invalide : ${attendu(issue.expected)} attendu` };
        }
        case z.ZodIssueCode.invalid_literal:
            return { message: `valeur attendue : ${JSON.stringify(issue.expected)}` };
        case z.ZodIssueCode.unrecognized_keys:
            return {
                message: `champ(s) inconnu(s) : ${issue.keys.join(', ')} — vérifiez l’orthographe`,
            };
        case z.ZodIssueCode.invalid_union:
            return { message: 'valeur ne correspond à aucune forme autorisée' };
        case z.ZodIssueCode.invalid_enum_value:
            return { message: `valeur « ${String(issue.received)} » hors de la liste autorisée` };
        case z.ZodIssueCode.too_small: {
            if (issue.type === 'string') {
                return { message: `chaîne trop courte (minimum ${issue.minimum} caractères)` };
            }
            if (issue.type === 'array') {
                return { message: `tableau trop court (minimum ${issue.minimum} élément(s))` };
            }
            return { message: `valeur trop petite (minimum ${issue.minimum})` };
        }
        case z.ZodIssueCode.too_big: {
            if (issue.type === 'string') {
                return { message: `chaîne trop longue (maximum ${issue.maximum} caractères)` };
            }
            if (issue.type === 'array') {
                return { message: `tableau trop long (maximum ${issue.maximum} élément(s))` };
            }
            return { message: `valeur trop grande (maximum ${issue.maximum})` };
        }
        case z.ZodIssueCode.invalid_string:
            return { message: 'format de chaîne invalide' };
        case z.ZodIssueCode.not_multiple_of:
            return { message: `la valeur doit être un multiple de ${issue.multipleOf}` };
        case z.ZodIssueCode.invalid_date:
            return { message: 'date invalide' };
        default:
            // Un message personnalisé (fourni par le schéma) prime toujours.
            return { message: contexte.defaultError };
    }
};
z.setErrorMap(carteErreursFrancais);
//# sourceMappingURL=zod-fr.js.map